import { DiagnosisConstants } from './diagnosis.constants'
import { IDiagnosisAction, IDiagnosisState } from './diagnosis.types'

export const initialDiagnosisState: IDiagnosisState = {
  initialPatientAcuity: null,
  initialPatientAcuityPNNV: null,
  organSystems: [],
  organSystemsPNNV: null,
  symptoms: [],
  symptomsPNNVs: [],
  impressions: [],
  impressionsPNNV: null,
  anatomicLocation: [],
  anatomicLocationPNNV: null,
  workingDiagnosis: '',
  finalPatientAcuity: null,
  finalPatientAcuityPNNV: null,
  conditionAtDestination: null,
}

export function diagnosisReducer(
  state: IDiagnosisState = initialDiagnosisState,
  action: IDiagnosisAction
): IDiagnosisState {
  switch (action.type) {
    case DiagnosisConstants.SET_INITIAL_PATIENT_ACUITY:
      return { ...state, initialPatientAcuity: action.initialPatientAcuity }
    case DiagnosisConstants.SET_INITIAL_PATIENT_ACUITY_PNNV:
      return { ...state, initialPatientAcuityPNNV: action.initialPatientAcuityPNNV }
    case DiagnosisConstants.SET_ORGAN_SYSTEM:
      return { ...state, organSystems: action.organSystems }
    case DiagnosisConstants.SET_ORGAN_SYSTEM_PNNV:
      return { ...state, organSystemsPNNV: action.organSystemsPNNV }
    case DiagnosisConstants.SET_SYMPTOMS:
      return { ...state, symptoms: action.symptoms }
    case DiagnosisConstants.SET_SYMPTOMS_PNNVS:
      return { ...state, symptomsPNNVs: action.symptomsPNNVs }
    case DiagnosisConstants.SET_IMPRESSIONS:
      return { ...state, impressions: action.impressions }
    case DiagnosisConstants.SET_IMPRESSIONS_PNNV:
      return { ...state, impressionsPNNV: action.impressionsPNNV }
    case DiagnosisConstants.SET_ANATOMIC_LOCATION:
      return { ...state, anatomicLocation: action.anatomicLocation }
    case DiagnosisConstants.SET_ANATOMIC_LOCATION_PNNV:
      return { ...state, anatomicLocationPNNV: action.anatomicLocationPNNV }
    case DiagnosisConstants.SET_WORKING_DIAGNOSIS:
      return { ...state, workingDiagnosis: action.workingDiagnosis }
    case DiagnosisConstants.SET_FINAL_PATIENT_ACUITY:
      return { ...state, finalPatientAcuity: action.finalPatientAcuity }
    case DiagnosisConstants.SET_FINAL_PATIENT_ACUITY_PNNV:
      return { ...state, finalPatientAcuityPNNV: action.finalPatientAcuityPNNV }
    case DiagnosisConstants.SET_CONDITION_AT_DESTINATION:
      return { ...state, conditionAtDestination: action.conditionAtDestination }
    case DiagnosisConstants.SET_DIAGNOSIS_STATE:
      return { ...action.diagnosis }
    case DiagnosisConstants.RESET_DIAGNOSIS:
      return {
        initialPatientAcuity: null,
        initialPatientAcuityPNNV: null,
        organSystems: [],
        organSystemsPNNV: null,
        symptoms: [],
        symptomsPNNVs: [],
        impressions: [],
        impressionsPNNV: null,
        anatomicLocation: [],
        anatomicLocationPNNV: null,
        workingDiagnosis: '',
        finalPatientAcuity: null,
        finalPatientAcuityPNNV: null,
        conditionAtDestination: null,
      }
    default:
      return state
  }
}
